module.exports = __webpack_public_path__ + "01_short_black.bffa3e34.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/01_short_black.png
// module id = uCUe
// module chunks = 0